import { Button, Col, Row } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ADD_MED_TO_INVENTORY,
  SET_INVENTORY_MED,
  SET_PATIENT_PACKET,
  SET_PRESCRIPTION_MEDICINES,
  SET_REQUISITION_MED,
} from "../../ActionTypes/ActionTypes";
import InventorisedMeds from "./InventorisedMeds";
import MedicinesToInvPage from "./MedicinesToInvPage";

class MedicinesPage extends Component {
  inventorizeMeds = () => {
    const {
      match,
      orders,
      patient_packet,
      inventorized_meds,
      setPatientPacket,
      history,
    } = this.props;
    if (patient_packet === "") {
      /*
                if not patient_packet -
                    1. remove the internal id's
                    2. create a patient_packet
            */
      const inv_meds = [];
      // eslint-disable-next-line
      inventorized_meds.map((med) => {
        delete med.id;
        delete med.name;
        inv_meds.push(med);
      });

      const { order_id } = match.params;
      const order = orders.filter(
        (ord) => Number(ord.id) === Number(order_id)
      )[0];

      if (order !== undefined) {
        const refillID = order.last_refill.id;

        axios({
          method: "post",
          url: "/patient_packets.json",
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            patient_packet: {
              carefill_id: refillID,
              medicine_strips: inv_meds,
            },
          },
        }).then((response) => {
          axios({
            method: "put",
            url: `/carefills/${refillID}.json`,
            headers: { Authorization: sessionStorage.getItem("jwtToken") },
            data: {
              carefill: {
                carefill_status: 1,
              },
            },
          }).then(() => {
            // console.log(resp.data);
            setPatientPacket(response.data.id);
            history.push("/inventory");
          });
        });
      }
    }
  };

  render() {
    const { match, patient_packet, history } = this.props;
    const { order_id } = match.params;

    return (
      <div style={{ marginBottom: 50 }}>
        <div style={{ marginBottom: 50, textAlign: "center" }}>
          <h1>Prescription Medicines in – {order_id}</h1>
          <hr width="300" />
        </div>

        <Row type="flex" justify="space-around">
          <Col span={8}>
            <h5 style={{ textAlign: "center" }}>Medicines</h5>
            <hr width="100" />

            <MedicinesToInvPage />
          </Col>

          <Col span={15}>
            <h5 style={{ textAlign: "center" }}>In Inventory</h5>
            <hr width="100" />

            <InventorisedMeds />
          </Col>
        </Row>

        {patient_packet === "" ? (
          <div style={{ textAlign: "center", marginTop: 60 }}>
            <Button type="primary" onClick={this.inventorizeMeds}>
              Submit
            </Button>
          </div>
        ) : (
          <div style={{ textAlign: "center", marginTop: 60 }}>
            <Button type="primary" onClick={() => history.push("/inventory")}>
              Done
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.InventoryState.orders,
  prescription_meds: state.InventoryState.prescription_medicines,
  inventorized_meds: state.InventoryState.inventorized_medicines,
  patient_packet: state.InventoryState.patient_packet,
});

const mapDispatchToProps = (dispatch) => ({
  setPrescriptionMeds: (data) =>
    dispatch({ type: SET_PRESCRIPTION_MEDICINES, payload: { meds: data } }),
  setInventoryMeds: (data) =>
    dispatch({ type: SET_INVENTORY_MED, payload: { meds: data } }),
  addMedToInventory: (data) =>
    dispatch({ type: ADD_MED_TO_INVENTORY, payload: { meds: data } }),
  setRequisitionMeds: (data) =>
    dispatch({ type: SET_REQUISITION_MED, payload: { meds: data } }),
  setPatientPacket: (packet_id) =>
    dispatch({ type: SET_PATIENT_PACKET, payload: { packet_id } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(MedicinesPage);



// WEBPACK FOOTER //
// ./src/component/Inventory/MedicinesPage.js